import { Checkbox, Col, DatePicker, Form, Input, InputNumber, Row } from 'antd'
import withSort from '../../../elements/HOC/withSort'
import useFetchSelectUrl from '../../../elements/Hooks/useFetchSelectUrl'
import CustomSelect from '../../../elements/Select/CustomSelect'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import withData from '../../../elements/Select/withData'
import { get, isEmpty } from 'lodash'
import { defaultFormItemLayout } from '../../../modules/FormItems'
import { dateVal } from '../../../modules/Utils'
import React from 'react'

import { compose } from 'recompose'

const CategorySelect = compose(
  withData({
    data: [
      { key: 'Loan', value: 'Loan' },
      { key: 'Advance', value: 'Advance' },
      { key: 'Deduction', value: 'Deduction' },
    ],
  }),
  withSort
)(CustomSelect)

function EmployeeLoanForm(props) {
  const { getFieldDecorator, getFieldValue } = props.form
  const { employeeLoan } = props
  let company = getFieldValue('company._id') || get(employeeLoan, 'company._id')
  company = company && company.replace('members/', '')
  const [CompanyRepSelect] = useFetchSelectUrl(
    {
      name: 'companyRep',
      url: `members/${company}/representatives`,
      cache: true,
      forceFetch: true,
    },
    [company],
    isEmpty(company)
  )

  const subCategory = {
    Loan: [],
    Advance: [],
    Detection: [{ key: 'CP38', value: 'CP38' }],
  }

  const SubCategorySelect = compose(
    withData({
      data: subCategory[getFieldValue('category') || 'Loan'],
    }),
    withSort
  )(CustomSelect)
  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Loan Date">
            {getFieldDecorator('orderDate', {
              initialValue: dateVal(employeeLoan, 'orderDate'),
              rules: [{ required: true, message: 'Please Select a Loan Date!' }],
            })(<DatePicker style={{ width: '100%' }} placeholder="Loan Date" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Payroll Deductible">
            {getFieldDecorator('deductible', {
              initialValue: get(employeeLoan, 'deductible') || true,
              valuePropName: 'checked',
            })(<Checkbox />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Title">
            {getFieldDecorator('title', {
              initialValue: get(employeeLoan, 'title'),
            })(<Input style={{ width: '250%' }} />)}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Amount">
            {getFieldDecorator('valueAmount', {
              initialValue: get(employeeLoan, 'valueAmount'),
              rules: [{ required: true, message: 'Please Select a Amount!' }],
            })(
              <InputNumber
                // disabled={isEdit || isBankTransfer}
                style={{ width: '100%' }}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Category">
            {getFieldDecorator('category', {
              initialValue: get(employeeLoan, 'category'),
              rules: [{ required: true, message: 'Please Select a Category!' }],
            })(<CategorySelect style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Sub Category">
            {getFieldDecorator('subCategory', {
              initialValue: get(employeeLoan, 'subCategory'),
            })(<SubCategorySelect style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="MONDIALE details">
            {getFieldDecorator('company._id', {
              initialValue: get(employeeLoan, 'company._id'),
              rules: [{ required: true, message: 'Please Select a company!' }],
            })(<OrganisationsSelect />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="HR">
            {getFieldDecorator('hr._id', {
              initialValue: get(employeeLoan, 'hr._id'),
              rules: [{ required: true, message: 'Please Select HR contact!' }],
            })(<CompanyRepSelect keyAtr={'_id'} valueAtr={'name'} />)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

EmployeeLoanForm.propTypes = {}
EmployeeLoanForm.defaultProps = {}

export default Form.create()((EmployeeLoanForm))
